import { PositionSource } from '@/signalr';
import type { PositionSource as UiPositionSource } from '@/ui';

export function toUiPositionSource(positionSource: PositionSource): UiPositionSource {
  switch (positionSource) {
    case PositionSource.Manual:
      return 'manual';
    case PositionSource.MobileApp:
      return 'mobileApp';
    case PositionSource.WebApp:
      return 'webApp';
    case PositionSource.Eed:
      return 'eed';
    case PositionSource.Aml:
      return 'aml';
  }
}
